import styled from "styled-components";

export const TitleWithIcon = styled.div`
  display: flex;
  margin-bottom: 40px;
  img {
    width: 25px;
    height: 25px;
    margin-left: 30px;
  }
`;

export const H4 = styled.h4`
  font-weight: 700;
  font-size: 25px;
  color: #000000;
  margin-bottom: 10px;
`;

export const TitleIcon = styled.div`
  display: flex;
  margin-bottom: 50px;

  align-items: center;

  div {
    margin-left: 20px;
  }
`;

export const RowCenter = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  margin-bottom: 15px;

  p {
    margin: 20px 0 0 0;
    font-size: 18px;
    font-weight: 400;
    line-height: 24.51px;
  }
`;

export const SubTitle = styled.div`
  margin: 15px 0 30px 0;

  p {
    font-weight: 700;
    font-size: 20px;
    line-height: 24px;
    color: #000000;
  }

  span {
    width: 70px;
    height: 1px;
    background-color: #007aff;
    display: block;
  }
`;

export const Number = styled.div`
  color: #fefefe;
  width: 26px;
  height: 26px;
  background: #000000;
  border-radius: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 15px;

  span {
    position: relative;
    top: 3px;
  }
`;

export const ItemNumber = styled.div`
  display: flex;
  align-items: center;
`;

export const Text = styled.div`
  font-weight: ${(props) => (props.strongText ? "700;" : "400;")};
  font-size: ${(props) => (props.strongText ? "16px;" : "14px;")};
`;

export const ContentIsLoading = styled.div`
  margin: 30px 0 60px 0;
`;

export const Content = styled.div`
  border-radius: 10px;
  border: 1px solid #e8e8e8;
  padding: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 25px;
`;

export const ContentRate = styled.div`
  border: 0;
  width: 190px;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    font-size: 26px;
  }
`;

export const ButtonsFooter = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-top: 60px;
`;

export const FinalizedText = styled.div`
  display: flex;
  flex-direction: column;

  p {
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    color: #000000;
  }

  span {
    font-weight: 400;
    font-size: 14px;
  }
`;

export const ReviewAboutPartner = styled.div`
  p {
    font-size: 14px;
    font-weight: 400;
  }

  .title {
    font-weight: 600;
    margin-bottom: 10px;
  }
`;
